export enum CheckoutProgress {
  start,
  inProgress,
  end,
}
